module.exports = __webpack_public_path__ + "static/media/VisualPerceptualbea5a140.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/VisualPerceptual.svg
// module id = 1312
// module chunks = 0